import React from 'react';
// import Footer from './Footer';
import ScrollToTopButton from './ScrollToTopButton';
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';

const Layout = ({ children }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div>
      {/* <Navbar /> */}
      <main className={language == "en" ? "ltr" : "rtl"}>{children}</main>
      {/* <Footer /> */}
      <ScrollToTopButton />
    </div>
  );
};

export default Layout;
